var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from "react";
import { useRef, useState } from "react";
import styled from "styled-components";
import { scrollToRef } from "./";
import { BaseButton } from "../components/styleComponents";
var ToggleButton = styled(BaseButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 1rem;\n"], ["\n  margin-top: 1rem;\n"])));

var Togglable = function Togglable(_a) {
  var initiallyVisible = _a.initiallyVisible,
      hideButtonText = _a.hideButtonText,
      displayButtonText = _a.displayButtonText,
      children = _a.children,
      scrollRef = _a.scrollRef;
  var ref = useState(useRef(null))[0];

  var _b = useState(initiallyVisible),
      toggled = _b[0],
      setToggled = _b[1];

  var toggle = function toggle() {
    setToggled(!toggled);
    toggled ? scrollRef && scrollToRef(scrollRef) : scrollToRef(ref);
  };

  return React.createElement(React.Fragment, null, React.createElement("div", {
    ref: ref
  }), React.createElement(ToggleButton, {
    variant: "outlined",
    color: "default",
    onClick: toggle
  }, toggled ? hideButtonText : displayButtonText), toggled && children);
};

export default Togglable;
var templateObject_1;